export interface GestionnaireItem {
  id: number;
  title: string;
  category: string;
  description: string;
  aiSuggestion: string;
  kpiScore: number;
  imageUrl?: string;
  isCompleted?: boolean;
}

export const gestionnairesData: GestionnaireItem[] = [
  {
    id: 1,
    title: "Tableau de Bord Gestionnaire",
    category: "KPI & Performance",
    description: "Dashboard personnalisé: KPI équipe, charge de travail, projets en cours, budget consommé, performance individuelle. Vue 360° en temps réel.",
    aiSuggestion: "Un gestionnaire sans dashboard, c'est comme piloter à l'aveugle. Ce tableau de bord te donne TOUTES les métriques critiques pour prendre des décisions éclairées.",
    kpiScore: 92,
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f72?w=800&q=80"
  },
  {
    id: 2,
    title: "RACI - Qui Fait Quoi",
    category: "Gouvernance",
    description: "Matrice RACI claire pour chaque projet/processus. Élimine confusion, évite doublons, accélère exécution. Responsabilités cristallines.",
    aiSuggestion: "90% des problèmes d'équipe viennent de rôles flous. Le RACI élimine le 'Je pensais que c'était toi' et le 'Personne ne l'a fait'. Clarté = vitesse.",
    kpiScore: 95,
    imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80"
  },
  {
    id: 3,
    title: "1-on-1 Structurés",
    category: "Leadership",
    description: "Framework rencontres individuelles: template agenda, questions coaching, suivi actions, documentation évolution. Investissement #1 rétention talents.",
    aiSuggestion: "Les meilleurs gestionnaires passent 40% de leur temps en 1-on-1. C'est là que tu détectes problèmes AVANT qu'ils explosent et que tu développes tes champions.",
    kpiScore: 88,
    imageUrl: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&q=80"
  },
  {
    id: 4,
    title: "Gestion Charge de Travail",
    category: "Opérations",
    description: "Outil de priorisation et allocation: capacité équipe vs demandes, identification goulots, équilibrage charge, prévention burnout.",
    aiSuggestion: "Ton équipe est surchargée? Ou sous-utilisée? Ce tool te montre EXACTEMENT où sont les bottlenecks et comment redistribuer intelligemment.",
    kpiScore: 85,
    imageUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
  },
  {
    id: 5,
    title: "Budget & ROI Projets",
    category: "Finance",
    description: "Tracking budget département: dépenses vs prévu, ROI projets mesurés, justifications augmentations, optimisations identifiées.",
    aiSuggestion: "CFO te demande de justifier ton budget? Boom - voici les chiffres. ROI démontré, économies réalisées, valeur créée. Langage qu'ils comprennent.",
    kpiScore: 90,
    imageUrl: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=800&q=80"
  },
  {
    id: 6,
    title: "Plan Développement Équipe",
    category: "Talent",
    description: "Cartographie compétences: forces/faiblesses chaque membre, plans formation personnalisés, succession planning, pipeline leadership.",
    aiSuggestion: "Ton meilleur employé part demain - t'es dans marde? OU tu as 2 personnes prêtes à prendre la relève parce que tu planifies? Le choix est clair.",
    kpiScore: 87,
    imageUrl: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80"
  },
  {
    id: 7,
    title: "Résolution Problèmes Structurée",
    category: "Méthodologie",
    description: "Framework résolution problèmes: 5 Whys, Ishikawa, PDCA. Analyse root cause, solutions mesurables, suivi efficacité, capitalisation leçons.",
    aiSuggestion: "Arrête de firefighter. Cette méthodo t'apprend à RÉGLER les problèmes définitivement, pas juste mettre des Band-Aids qui reviennent dans 2 semaines.",
    kpiScore: 82,
    imageUrl: "https://images.unsplash.com/photo-1531403009284-440f080d1e12?w=800&q=80"
  },
  {
    id: 8,
    title: "Communication d'Équipe",
    category: "Leadership",
    description: "Plan communication: meetings efficaces (agenda, PV, actions), newsletters équipe, célébrations victoires, transparence décisions.",
    aiSuggestion: "Ton équipe se plaint de pas savoir ce qui se passe? Communication structure = engagement +40%. Ça prend 2h/semaine, ça rapporte 100h de productivité.",
    kpiScore: 86,
    imageUrl: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80"
  },
  {
    id: 9,
    title: "Matrice Décisions",
    category: "Gouvernance",
    description: "Framework prise décision: quelles décisions tu prends seul, consultatif, consensus, déléguées. Accélère exécution, autonomise équipe.",
    aiSuggestion: "Tu micromanages OU tu es absent? La matrice décision clarifie EXACTEMENT quand tu décides seul vs quand tu consultes. Fini les 'Je savais pas si je pouvais décider'.",
    kpiScore: 84,
    imageUrl: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=800&q=80"
  },
  {
    id: 10,
    title: "Revue Performance Trimestrielle",
    category: "KPI & Performance",
    description: "Process évaluation 90j: objectifs atteints, feedback 360°, ajustements, reconnaissance, plan action trimestre suivant. Pas attendre fin année.",
    aiSuggestion: "Évaluation annuelle? Trop tard pour corriger. Revues trimestrielles gardent tout le monde aligné, motivé et performant. C'est du coaching continu, pas du jugement annuel.",
    kpiScore: 89,
    imageUrl: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&q=80"
  },
  {
    id: 11,
    title: "Gestion Conflits",
    category: "Leadership",
    description: "Méthodes résolution conflits interpersonnels: écoute active, médiation, négociation win-win, recadrage constructif. Préserve cohésion équipe.",
    aiSuggestion: "Conflit dans l'équipe? Ignoré = cancer qui métastase. Géré vite et bien = opportunité de croissance. Ce framework transforme tensions en collaboration.",
    kpiScore: 83,
    imageUrl: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80"
  },
  {
    id: 12,
    title: "Automatisation Reportings",
    category: "Opérations",
    description: "Dashboards automatisés remplaçant rapports Excel manuels: Power BI, Tableau, Google Data Studio. Temps économisé = focus stratégie.",
    aiSuggestion: "Tu passes 5h/semaine à faire des rapports Excel? Automatise ça. Ces 5h retournent en coaching, amélioration processus, innovation. ROI immédiat.",
    kpiScore: 91,
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f72?w=800&q=80"
  },
  {
    id: 13,
    title: "Indicateurs Engagement",
    category: "Talent",
    description: "Mesure engagement équipe: sondages pulse trimestriels, taux rétention, eNPS, absentéisme, participation initiatives. Détection précoce désengagement.",
    aiSuggestion: "Ton meilleur employé démissionne et tu es surpris? Les signaux étaient là. Ces KPI te montrent QUI est à risque AVANT qu'il parte. Prévention > réaction.",
    kpiScore: 88,
    imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80"
  },
  {
    id: 14,
    title: "Délégation Efficace",
    category: "Leadership",
    description: "Framework délégation: quoi déléguer, à qui, comment (brief complet, ressources, autonomie, checkpoints), suivi sans micromanagement.",
    aiSuggestion: "Tu travailles 60h/semaine pendant que ton équipe est sous-utilisée? Délégation structure libère 20h/semaine ET développe ton équipe. Double gain.",
    kpiScore: 87,
    imageUrl: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80"
  },
  {
    id: 15,
    title: "Amélioration Continue (Kaizen)",
    category: "Méthodologie",
    description: "Culture amélioration continue: retrospectives sprint, suggestion box, quick wins célébrés, temps dédié innovation (10% temps équipe).",
    aiSuggestion: "Équipes sans Kaizen stagnent. Équipes avec Kaizen améliorent 5%/trimestre composé = +20%/an. Petites améliorations continues = transformation massive.",
    kpiScore: 86,
    imageUrl: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80"
  },
  {
    id: 16,
    title: "Reconnaissance & Célébrations",
    category: "Leadership",
    description: "Programme reconnaissance structuré: célébrations victoires (petites et grandes), feedback positif régulier, prime performance, événements équipe.",
    aiSuggestion: "Reconnaissance coûte rien, rapporte tout. Équipes reconnues = engagement +30%, turnover -40%, productivité +15%. C'est mathématique.",
    kpiScore: 85,
    imageUrl: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=800&q=80"
  },
  {
    id: 17,
    title: "Planification Sprint/Trimestre",
    category: "Opérations",
    description: "Méthode planification Agile adaptée: sprints 2 semaines OU trimestres, OKR définis, capacity planning, daily standups, retrospectives.",
    aiSuggestion: "Navigation à vue = chaos. Planification structurée = clarté + vélocité. Ton équipe sait EXACTEMENT quoi faire, pourquoi, et pour quand. Exécution 2x plus rapide.",
    kpiScore: 89,
    imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80"
  },
  {
    id: 18,
    title: "Onboarding Nouveaux",
    category: "Talent",
    description: "Programme onboarding structuré: checklist 30-60-90 jours, buddy system, formations essentielles, quick wins premiers mois, feedback régulier.",
    aiSuggestion: "Nouvelle recrue quitte après 3 mois? Coût = 50k$+ (recrutement + formation perdue). Onboarding structure = rétention +60%, productivité plus rapide, satisfaction élevée.",
    kpiScore: 84,
    imageUrl: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80"
  },
  {
    id: 19,
    title: "Gestion Crises",
    category: "Méthodologie",
    description: "Plan gestion crises: procédures escalation, communication stakeholders, war room, post-mortem, leçons capitalisées. Prêt pour l'inattendu.",
    aiSuggestion: "Crise arrive (client majeur furieux, système down, erreur grosse) - tu paniques OU tu actives ton plan? Préparation = différence entre panique et leadership.",
    kpiScore: 81,
    imageUrl: "https://images.unsplash.com/photo-1584438784894-089d6a62b8fa?w=800&q=80"
  },
  {
    id: 20,
    title: "Intelligence Émotionnelle",
    category: "Leadership",
    description: "Développement IE gestionnaire: self-awareness, régulation émotions, empathie, compétences sociales. Foundation leadership authentique.",
    aiSuggestion: "QI te fait embaucher, IE te fait promouvoir. Gestionnaires haute IE = équipes +25% plus performantes, +40% rétention. C'est THE skill à développer.",
    kpiScore: 90,
    imageUrl: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&q=80"
  }
];

